import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

const deleteComparisonReport = async (reportId: string): Promise<void> => {
    let token = '';
    try { token = localStorage.getItem('accessToken') ?? ''; } catch {}
    await axios(tpoGenUrls.deleteComparisonReport(reportId), {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
    });
};

interface UseDeleteComparisonReportOptions {
    onSuccess?: () => void;
    successMessage?: string;
    errorMessage?: string;
}

const useDeleteComparisonReportMutation = ({
    onSuccess,
    successMessage = 'Comparison report deleted',
    errorMessage = 'Failed to delete comparison report',
}: UseDeleteComparisonReportOptions = {}) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: (reportId: string) => deleteComparisonReport(reportId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.comparisonReports() });
            sendNotification('success', successMessage);
            onSuccess?.();
        },
        onError: (error: unknown) => {
            const err = error as { response?: { data?: { detail?: unknown; message?: string } }; message?: string };
            const message = err?.response?.data?.detail;
            const resolved = typeof message === 'string' ? message
                : err?.response?.data?.message ?? err?.message ?? errorMessage;
            sendNotification('error', typeof resolved === 'string' ? resolved : errorMessage);
        },
    });

    return { mutate, isPending };
};

export default useDeleteComparisonReportMutation;
